import { buildQueryReducerKey } from './BuildQueryConstants';

export function buildQuery(state) {
  return state.get(buildQueryReducerKey);
}

export function query(state) {
  return buildQuery(state).get('query');
}

export function isFormsButtonsEnabled(state) {
  return buildQuery(state).get('isFormsButtonsEnabled');
}

export function isClassicLicense(state) {
  return buildQuery(state).get('isClassicLicense');
}

export function structurePreview(state) {
  return buildQuery(state).get('structurePreview');
}

export function previewSize(state) {
  return buildQuery(state).get('previewSize');
}

export function dbs(state) {
  return buildQuery(state).get('dbs');
}

export function qsForms(state) {
  return buildQuery(state).get('qsForms');
}
